import {
  SAVE_SETTINGS,
  FETCH_START,
  FETCH_SUCCESS,
  FETCH_ERROR
} from 'shared/constants/ActionTypes';
import { API } from 'shared/constants/AppEnums';
import jwtAxios from '@crema/services/auth/jwt-auth';
import { showMessage } from './Common';

export const onPutSidebarSetting = (data)=>{
    return (dispatch) => {
        let url = API.BASE_URL + 'bridge/profile/me/';
        dispatch({ type: FETCH_START });
        jwtAxios
        .put(url, data, API.requestOptionsPUT())
        .then((data) => {
            if (data.status === 200) {
                dispatch({ type: FETCH_SUCCESS });
                dispatch(showMessage('Simpan Profile Berhasil'));
            } else {
                dispatch({
                    type: FETCH_ERROR,
                    payload: 'Terjadi Kesalahan',
                });
            }
        })
        .catch((error) => {
            dispatch({ type: FETCH_ERROR, payload: error.message });
        });
    }
}
  